import React, { useEffect, useState } from 'react'
import ReportPage from '../reportPage.v2'
import { connect } from 'react-redux'
import LocksStatusGraph, { intervals } from './locksStatusGraph'
import { fetchLockReports, fetchLockSummary } from '../../../state/actions/vehicles'
import { useAuth0 } from '@auth0/auth0-react'
import { getDayName } from '@modul-connect/shared/utils/text'
import { DateTime } from 'luxon'
import { dateTimeToString } from '@modul-connect/shared/utils/dateTimeUtils'
import TableWidgetSeparated from '@modul-connect/shared/components/molecules/tableWidget/tableWidgetSeparated.v2'
import { log_columns } from './log_columns'
import { getServiceList } from '../../../utils/ServiceList'
import { ServiceType } from '@modul-connect/shared/utils/services'
import { getDaysDifference } from '../../fleet/vehicles/vehicle/logGraphs/logGraphs'


const LockReportPage = ({
  vehicles_locks,
  fetchLockSummary,
  fetchLockReports,
  loading,
  themes,
  subtrees,
  selected_organisations
}) => {
  const disabled = !getServiceList({ subtrees }).hasServiceForSelected(selected_organisations, ServiceType.LocksReports)
  const { getAccessTokenSilently } = useAuth0()

  const [reportData, setReportLogs] = useState(null)
  const [data, setData] = useState({})

  const [lockStartTime, setLockStartTime] = React.useState(DateTime.now().startOf('day'))
  const [lockEndTime, setLockEndTime] = React.useState(DateTime.now())


  const getDaysForFetching = (startTime, endTime) => {
    return getDaysDifference(startTime, endTime)
  }

  useEffect(() => {
    getAccessTokenSilently()
      .then((accessToken) => {
        fetchLockSummary(accessToken, getDaysForFetching(lockStartTime, lockEndTime))
        fetchLockReports(accessToken, getDaysForFetching(lockStartTime, lockEndTime))
      })
  }, [lockStartTime, lockEndTime, selected_organisations])

  useEffect(() => {
    let nextId = -1
    const preparedData = []

    const logs = vehicles_locks?.history
    if (logs && logs.length >= 0) {
      setReportLogs(logs.map(log => {
        nextId++
        preparedData.push({
          id: nextId,
          boxId: log.mainboxId,
          timestamp_locked: log.lockedAt ? DateTime.fromISO(log.lockedAt) : null,
          timestamp_unLockedAt: log.unLockedAt ? DateTime.fromISO(log.unLockedAt) : null,
          vehicle: log.vehicleName,
          vin: log.vin,
          endTimeString: log.unLockedAt ? dateTimeToString(DateTime.fromISO(log.unLockedAt), 'time-only') : null,
          startTimeString: log.lockedAt ? dateTimeToString(DateTime.fromISO(log.lockedAt), 'time-only') : null,
          status: 
          {
            value: log.isLocked ? 'Locked' : 'Unlocked',
            guard: log.isLocked
          }
        })
      }))
    }

    if (preparedData && preparedData.length > 0) {
      setData(getDataByDay(preparedData))
    } else {
      setData({})
    }

  },[vehicles_locks])

  const getDataByDay = (data) => {

    const dividedByDay = {}
    let dailyList = []

    let prevTimestamp = ''

    if (data?.length) {
      data.forEach(log => {

        if (prevTimestamp && (log.timestamp_locked.startOf('day').toMillis() !== prevTimestamp.startOf('day').toMillis())) {

          dividedByDay[prevTimestamp] = [...dailyList]
          dailyList = []
        }
        dailyList.push(log)
        prevTimestamp = log.timestamp_locked
      })
    }
    if (dailyList.length > 0) {

      dividedByDay[prevTimestamp] = [...dailyList]
    }
    return dividedByDay
  }

  const tables = (
    Object.keys(data)?.length ? Object.keys(data).map(key => {
      const log = data[key]
      return <TableWidgetSeparated
        tableTitle={getDayName(DateTime.fromISO(key))}
        key={key}
        data={log}
        loadingStatus={loading.fetchLockReports}
        totalItems={reportData}
        columns={log_columns}
        themes={themes}
        isSortable={false}
        pagination={false}
        rowsOptions={[log?.length]}
      />
    }) : []
  )

  return(
    <ReportPage
      disabled={disabled}
      noPadding
      noBackground
      noTimePickerBar
      noSearch
      kpi={<LocksStatusGraph 
        oldPicker={false}
        setStartTime={setLockStartTime}
        setEndTime={setLockEndTime}
        startTime={lockStartTime}
        endTime={lockEndTime}
        data={vehicles_locks?.summary} 
        isLoading={loading.fetchLockSummary ===  'loading'}
        fetchingDataFailed={loading.fetchLockSummary === 'failed'}
      />}
      title={'Reports'}
      noDataMessage={'All the vehicles have been locked.'}
      tables={tables}
      isLoading={loading.fetchLockReports ===  'loading'}
      fetchingDataFailed={loading.fetchLockReports === 'failed'}
    >
    </ReportPage>
  )
}

const mapStateToProps = (props) => props

const mapDispatchToProps = (dispatch) => ({
  fetchLockSummary: (accessToken, days) => dispatch(fetchLockSummary(accessToken, days)),
  fetchLockReports: (accessToken, days) => dispatch(fetchLockReports(accessToken, days))
})

export default connect(mapStateToProps,mapDispatchToProps)(LockReportPage)
